import * as React from "react";
import * as ReactDOM from "react-dom";

import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as subpub from "./utils/subpub";
import {fetchUserInfo,getBindUsers,confTask3,bindFriend,joinAndFinish,voteTicket} from "./utils/fetch";
import {IUserInfo,IRanksInfo,IEntrys} from "./IViewObject";
import {
  CountDown,
  Dynamics,
  NewUserTitle,
  NewUserTask,
  PointInfo,
  SearchBox,
  BindFriends,
  Dialog,
  PagesLinks,
  Rules,
  MyPackage,
  UserInfo
} from "./components";
// import { getPageRouteKey } from "./route";
import * as styles from "./App.scss";

export interface IAppProps {
  /** class */
  className?: string;
}

export interface IAppState{
  userInfo:IUserInfo;
  curBindUser:IRanksInfo;
  historyBindUser:IRanksInfo[];
  confData: IEntrys[],  
  countDownStart:number;
  signTask:IEntrys,
  signCount:number,
  signHistory:any[]
}

@pureRender
export class App extends React.Component<IAppProps, IAppState> {

  constructor(props) {
    super(props);
    this.state={
      userInfo:{
          bindingNum:0,
          enable:false,
          tickets:0,
          scores:0
      },
      curBindUser:{
        nickname:"",
        yyuid:"",
        scores:""
      },
      historyBindUser:[
        {
          nickname:"",
          yyuid:"",
          scores:""
        }
      ],
      confData:[{
        gameId:"",
        serverId:"",
        tasks:[]
    }],
    countDownStart:0,
    signTask:{
        gameId:"",
        serverId:"",
        tasks:[]
    },
    signCount:0,
    signHistory:[]
  }

}
componentWillMount(){
  confTask3(window._CONFIG['ACTCODE'])
  .then((res:any)=>{
      if(res.status==200){
          let conf=[];
          res.data.entrys.map((item,index)=>{
              if(index<3){
                  conf.push({
                      gameId:item.gs.gameId,
                      serverId:item.gs.serverId,
                      tasks:item.tasks
                  })
              }
              
          })
           this.setState({
              confData:conf,
              countDownStart:res.data.serverTime,
              signTask:{
                gameId:res.data.entrys[3].gs.gameId,
                serverId:res.data.entrys[3].gs.serverId,
                tasks:res.data.entrys[3].tasks
              }
          })
      }
  })
  fetchUserInfo()
  .then((res:any)=>{
      if(res.status==200){
          this.setState({userInfo:res.data});
      }
  })
  .then(()=>{
     getBindUsers()
      .then((res:any)=>{
        if(res.status==200){
          if(res.data.binding!==null){
            this.setState({curBindUser:res.data.binding});
          }
          if(res.data.historys.length!=0){
            this.setState({
              historyBindUser:res.data.historys
            })
          }
        }
      })
      .then((res:any)=>{
        let shareYyuid=Number(f2eGame.util.getParam('yyuid'));
        let curBindYyuid=this.state.curBindUser.yyuid;
        f2eGame.port.udb.getUserInfo()
        .then((res:any)=>{

            if(!!shareYyuid&&shareYyuid!=res.yyid){
              if(curBindYyuid==shareYyuid) return;             
              let dialog=new f2eGameUI.Dialog({
                classNames:{
                  component:"min-pop"
                },
               buttons:[{
                 className:"btn-nobind",
                 callback:()=>{
                  dialog.close(true)
                 }
               },{
                 className:"btn-bind",
                 callback:()=>{
                  this.bind(shareYyuid)
                  dialog.close(true)
                  
                 }
               }]
              })
              let contTips="";
              if(!!curBindYyuid){
                 contTips=`${shareYyuid}邀请您解除已有绑定，并绑定TA为您新的游戏大使`;            
              }else{
                 contTips=`${shareYyuid}邀请您绑定TA为游戏大使。绑定后将自动支持TA`;            
                
              }
              ReactDOM.render(
                <Dialog shareYyuid={shareYyuid} curBindYyuid={curBindYyuid} contTips={contTips}/>,
                $('.f2e-dialog__body ')[0]
              )
            }
        })
      })
    })
  

    f2eGame.port.task3.signHistory({
        actCode:window._CONFIG['ACTCODE']
    })
    .then((res:any)=>{
        if(res.status==200){
            this.setState({
                signCount:res.data.signCount,
                signHistory:res.data.history
            })
        }
    })
}

  private bind(yyuid){

    bindFriend(yyuid)
    .then((res:any)=>{
        let cont="";
        if(res.status==200&&res.data){
            subpub.emit('bindSucc');
            cont="绑定成功！";
            
        }else if(res.status==551){
            cont=res.message;
        }else{
            cont="绑定失败！";
        }
        let dialog=new f2eGameUI.Dialog({
            classNames:{
                component:"min-pop"
            },
            content:cont,
            buttons:[{
                className:"btn-y",
                callback:()=>{
                    dialog.close(true)
                }
            }]
        })
    })
  }
  public componentDidMount() {
    
    subpub.on('bindSucc', () => {
      getBindUsers()
      .then((res:any)=>{
        if(res.status==200){
            this.setState({
                curBindUser:res.data.binding,
                historyBindUser:res.data.historys
            })           
            
        }
      })
    });
    subpub.on("voteSucc",()=>{
        this.getUserAndBindInfo()
    })
    subpub.on("freshUserAndBindInfo",()=>{
        
        this.getUserAndBindInfo(true);
    })
    subpub.on('getTaskAward',(e,param)=>{
        
      let {taskId,gameId,serverId,taskName,x,y,noTips,isClick}=param;
      let gameName=f2eGame.util.queryGame(gameId,"gameName");
      if(y==0){
          taskName="体验游戏"+taskName+"分钟"
      }else{
          taskName="等级达到"+taskName+"级"
          
      }
     if(this.state.confData[x].tasks[y].taskStatus == 100) return;
      
    if(this.state.confData[x].tasks[y].taskStatus == 1&&!noTips){
        joinAndFinish(window._CONFIG['ACTCODE'],taskId,gameId,serverId)
        .then((res:any)=>{    
            if(res.status==200){
                let awards=[];
                res.data.awards.map((item,index)=>{
                    awards.push(item.awardName);
                })
                let confData = Object.assign([],this.state.confData)
                confData[x].tasks[y].taskStatus = 100;    
                                       
                this.setState({confData});
                this.forceUpdate();
                
                this.getUserAndBindInfo()
                
                // 游戏5分钟
                if(y==0){
                    this.sign(awards.join(' '));
                }else{                    
                    let dialog=new f2eGameUI.Dialog({
                        classNames:{
                            component:"min-pop"
                        },
                        content:`恭喜您获得 ${awards.join(' ')}`,
                        buttons:[{
                            className:"btn-y",
                            callback:()=>{     
                                dialog.close(true)
                            }
                        }]
                    })
                }
            }else if(res.status==411){
            
                let dialog=new f2eGameUI.Dialog({
                    classNames:{
                        component:"min-pop"
                    },
                    content:`您今日还未达到领奖条件哦！<br/>【${taskName}】可领取`,
                    buttons:[{
                        className:"btn-continue",
                        callback:()=>{   
                            f2eGame.port.statpid.clickStat({eid:window.Global.statpidOption.eid+"/FHYX",eid_desc:window.Global.statpidOption.eid_desc+"/返回游戏"});
                            f2eGame.port.statpid.gameStat({
                                eid:window.Global.statpidOption.eid+"/FHYX",
                                eid_desc:window.Global.statpidOption.eid_desc+"/返回游戏",
                                gameId:gameId,
                                serverId:serverId,
                                gameName:gameName
                            })
                            dialog.close(true)
                        }
                    }]
                })
    
            }else{
                let dialog=new f2eGameUI.Dialog({
                    classNames:{
                        component:"min-pop"
                    },
                    content:res.message,
                    buttons:[{
                        className:"btn-y",
                        callback:()=>{     
                            dialog.close(true)
                        }
                    }]
                })
            }

            
        })
        return;
    }else{
        if(isClick){
            
            f2eGame.port.statpid.clickStat({eid:window.Global.statpidOption.eid+"/YX"+(x+1)+"RW"+(y+1),eid_desc:window.Global.statpidOption.eid_desc+"/游戏"+(x+1)+"任务"+(y+1)});
        }
        f2eGame.port.statpid.gameStat({
            eid:window.Global.statpidOption.eid+"/YX"+(x+1)+"RW"+(y+1),
            eid_desc:window.Global.statpidOption.eid_desc+"/游戏"+(x+1)+"任务"+(y+1),
            gameId:gameId,
            serverId:serverId,
            gameName:gameName
        })
    
        joinAndFinish(window._CONFIG['ACTCODE'],taskId,gameId,serverId)
        .then((res:any)=>{
    
            if(res.status==200){
                let awards=[];
                res.data.awards.map((item,index)=>{
                    awards.push(item.awardName);
                })
                let confData = Object.assign([],this.state.confData)
                confData[x].tasks[y].taskStatus = 100;    
                                        
                this.setState({confData});
                this.forceUpdate();
                
                this.getUserAndBindInfo()
                
                
                // 游戏5分钟
                if(y==0){
                    this.sign(awards.join(' '));
                }else{
                    let dialog=new f2eGameUI.Dialog({
                        classNames:{
                            component:"min-pop"
                        },
                        content:`恭喜您获得 ${awards.join(' ')}`,
                        buttons:[{
                            className:"btn-y",
                            callback:()=>{     
                                dialog.close(true);
                            }
                        }]
                    })

                }
            }else{
                let confData = Object.assign([],this.state.confData)
                confData[x].tasks[y].taskStatus = 1;    
                                        
                this.setState({confData});
                this.forceUpdate();
    
                
            }
    
                
            })
        
    
            
        }
    })

    

}

  public render() {
    const {　className } = this.props;
    const { userInfo,historyBindUser,curBindUser,confData,countDownStart,signCount } = this.state;
    const classNameSec = classnames(styles.container, className, "f-cb");
    // const active: string = getPageRouteKey();
    return (
      <div className={classNameSec} >
        <div className={styles.rule_package}>
            <Rules/>
            <MyPackage/>
        </div>
        <UserInfo/>
        <PagesLinks/>
        <div className={styles.top}>
          <Dynamics/>
          <CountDown countDownStart={countDownStart}/>
          <NewUserTitle signCount={signCount}/>
          
          
        </div>
        <div className={styles.main}>
          <NewUserTask userInfo={userInfo} confData={confData} curBindUser={curBindUser} signCount={signCount}/>
        </div>
        <div className={styles.bottom}>
            <div className={styles.bottom_left}>
              <PointInfo userInfo={userInfo}/>            
              <SearchBox curBindUser={curBindUser}/>  
            </div>
            <div className={styles.bottom_right}>
              <BindFriends curBindUser={curBindUser} historyBindUser={historyBindUser} confData={confData} userInfo={userInfo}/>
            </div>
        </div>
      </div>
    );
  }

    //   签到
    private sign=(taskAward:string)=>{
        let {signTask,signCount,signHistory}=this.state;

        let date=new Date().getFullYear()+""+(new Date().getMonth()+1)+""+new Date().getDate();
        let signToday=false;
        signHistory.map((item,index)=>{
            if(item==date){
                signToday=true;
            }
        })
        if(signToday){
            let dialog=new f2eGameUI.Dialog({
                classNames:{
                    component:'min-pop'
                },
                content:`恭喜您获得 ${taskAward}`,
                buttons:[{
                    className:"btn-y",
                    callback:()=>{
                        dialog.close(true);
                    }
                }]
            })
            return;
        }else{
            joinAndFinish(window._CONFIG['ACTCODE'],signTask.tasks[0].id,signTask.gameId,signTask.serverId)
            .then((res:any)=>{
                // 签到成功
                if(res.status==200){
                    this.setState({signCount:this.state.signCount+1})
                    let awards=[];
                    res.data.awards.map((item,index)=>{
                        awards.push(item.awardName);
                    })
                    let dialog=new f2eGameUI.Dialog({
                        classNames:{
                            component:'min-pop'
                        },
                        content:`恭喜您获得 ${awards.join(' ')} ${taskAward}`,
                        buttons:[{
                            className:"btn-y",
                            callback:()=>{
                                dialog.close(true);
                            }
                        }]
                    })
                    // 签到失败
                }else{
                    let dialog=new f2eGameUI.Dialog({
                        classNames:{
                            component:'min-pop'
                        },
                        content:`恭喜您获得 ${taskAward}`,
                        buttons:[{
                            className:"btn-y",
                            callback:()=>{
                                dialog.close(true);
                            }
                        }]
                    })
                }
            });
            
        }
    }       

    // 获取用户信息和历史绑定信息
    private getUserAndBindInfo=(dialog?:boolean)=>{
        fetchUserInfo()
        .then((res:any)=>{
            if(res.status==200){
                this.setState({userInfo:res.data});
            }
        })
        getBindUsers()
        .then((res:any)=>{
        
          if(res.status==200){
            if(res.data.binding!==null){
              this.setState({curBindUser:res.data.binding})            
            }
            if(res.data.historys.length!=0){
              this.setState({
                historyBindUser:res.data.historys
              })
            }

            // 是否弹窗提示
            if(dialog){
                let dialog=new f2eGameUI.Dialog({
                    classNames:{
                        component:"min-pop"
                    },
                    content:"刷新成功",
                    buttons:[{
                        className:'btn-y',
                        callback:()=>{
                            dialog.close(true)
                        }
                    }]
                })
            }
          }
        })
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx